import { useState, useEffect } from 'react';

export default function useDebounce<T>(value: T, delayInMs: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delayInMs);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delayInMs]);

  return debouncedValue;
}